/**
 * WHO-6643: a room name always starts with a capital, also when typed in lower
 * case. Its own module so the Apollo type policies can read every room name
 * through it (F24) without pulling the workspace utils into every page.
 */
export const capitalizeRoomName = (name: string) =>
  name.charAt(0).toLocaleUpperCase() + name.slice(1);
